import { render, staticRenderFns } from "./ProductRevealCheckbox.vue?vue&type=template&id=9696bbfe&scoped=true"
import script from "./ProductRevealCheckbox.vue?vue&type=script&lang=js"
export * from "./ProductRevealCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ProductRevealCheckbox.vue?vue&type=style&index=0&id=9696bbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9696bbfe",
  null
  
)

export default component.exports